import React from 'react'
import { Table } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'
import { MsProjectPreview } from '@/Services/MsProjectImportService'
import TaskImportSourceViewer from '@/Components/TaskImportSourceViewer/TaskImportSourceViewer'

type Props = {
  restrictions: MsProjectPreview['restrictions']
  onGoToProgrammingRow: (uid: string) => void
}

const RestrictionsTab = ({ restrictions, onGoToProgrammingRow }: Props) => {
  const { t } = useTranslation()

  if (!restrictions.length) return <div className="text-muted py-3">{t('MS_PROJECT_IMPORTER:NoRestrictions')}</div>

  return (
    <>
      <h5>{t('MS_PROJECT_IMPORTER:RestrictionsPreview')}</h5>
      <Table bordered hover size="sm" responsive>
        <thead>
          <tr>
            <th>{t('TASK_IMPORTER:TitleColumn')}</th>
            <th>{t('MS_PROJECT_IMPORTER:Restriction')}</th>
            <th>{t('TASK_IMPORTER:StartsAtColumn')}</th>
            <th>{t('TASK_IMPORT_SOURCE:Column')}</th>
          </tr>
        </thead>
        <tbody>{restrictions.slice(0, 10).map((restriction, index) => (
          <tr key={`${restriction.taskUid}-${index}`}>
            <td>{restriction.taskId} - <button type="button" className="ms-project-importer-task-link" onClick={() => onGoToProgrammingRow(restriction.taskUid)}>{restriction.taskName}</button></td>
            <td>{restriction.description}</td>
            <td>{restriction.date || '-'}</td>
            <td><TaskImportSourceViewer source={restriction.importSource} taskName={restriction.description} recordLabelKey="TASK_IMPORT_SOURCE:Restriction" relatedTask={{ id: restriction.taskId, name: restriction.taskName, onSelect: () => onGoToProgrammingRow(restriction.taskUid) }} compact /></td>
          </tr>
        ))}</tbody>
      </Table>
    </>
  )
}

export default RestrictionsTab
